import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getequipment_evaluationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "equipmentevaluation", ...action.payload }),
		);
		yield put({
			type: types.GET_EQUIPMENT_EVALUATION_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_EQUIPMENT_EVALUATION_ERROR,
			payload,
		});
	}
}

export function* getequipment_evaluationWatcherSaga() {
	yield takeLatest(
		types.GET_EQUIPMENT_EVALUATION_START,
		getequipment_evaluationHandlerSaga,
	);
}

//create

//delete

function* deleteequipment_evaluationHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("equipmentevaluation", action.payload),
		);
		yield put({
			type: types.DELETE_EQUIPMENT_EVALUATION_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_EQUIPMENT_EVALUATION_ERROR,
			payload,
		});
	}
}

export function* deleteequipment_evaluationWatcherSaga() {
	yield takeLatest(
		types.DELETE_EQUIPMENT_EVALUATION_START,
		deleteequipment_evaluationHandlerSaga,
	);
}

//update
